import { useContext } from 'react';

import { FacebookContext } from '../Contexts/index';

const useFacebookApi = () => {
  const context = useContext(FacebookContext);

  return context;
};

export default useFacebookApi;
